import { FormControl, FormControlProps, FormLabel, InputLabel, MenuItem, Select } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useConfigurationStore, useStateStore } from "src/lib/store"

const BatchReportTargetSelect = (props: FormControlProps) => {
  const { t } = useTranslation()
  const batchReportTargets = useConfigurationStore(state => state.batchReportTargets)
  const [batchReportTarget, setBatchReportTarget] = useStateStore(state => [state.batchReportTarget, state.setBatchReportTarget])

  return (
    <FormControl {...props} >
      <InputLabel id="batch-report-target">{t("labels.batchReportTarget")}</InputLabel>
      <Select id="batch-report-target" label={t("labels.batchReportTarget")} value={batchReportTarget?.id} onChange={(event) => setBatchReportTarget(batchReportTargets.find(batchReportTarget => batchReportTarget.id == event.target.value))}>
          {batchReportTargets.map(batchReportTarget => (
            <MenuItem key={batchReportTarget.id} value={batchReportTarget.id}>{batchReportTarget.name}</MenuItem>
          ))}
        </Select>
    </FormControl>
  )
}

export default BatchReportTargetSelect
